module.exports = __webpack_public_path__ + "static/media/macbook_pro_16.b0cc627a.svg";